export class ModelUtils {
    //-------------------------------------------------------------------------
    /**
     * Nastaveni opacity modelu (0 az 1). Opacity se nastavuje jen pro meshe daneho modelu, materialy nejsou ovlivneny.
     * Aby to fungovalo, tak materialy modelu musi mit blendMode.
     * @param model 
     * @param opacity 
     */
    //-------------------------------------------------------------------------
    static setOpacity(model: pc.ModelComponent, opacity: number): void {
        model.meshInstances.forEach((meshIns: pc.MeshInstance) => {
            meshIns.setParameter("material_opacity", opacity);
        });
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static cloneModelMaterials(model: pc.ModelComponent, data: object, originalMats: pc.StandardMaterial[], clonedMats: pc.StandardMaterial[], assets?: pc.AssetRegistry, assetPrefix?: string, replace: boolean = false): void {
        model.meshInstances.forEach((mesh: pc.MeshInstance, meshId: number) => {
            let mat = mesh.material as pc.StandardMaterial;
            let matId = originalMats.findIndex((m: pc.StandardMaterial): boolean => { return m == mat; });

            originalMats.push(mat);

            if (matId >= 0) {
                clonedMats.push(clonedMats[matId]);
            }
            else {
                clonedMats.push(ModelUtils.cloneMaterial(mat, data, assets, assetPrefix, replace));
            }
        });
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static cloneMaterial(material: pc.StandardMaterial, data: object, assets?: pc.AssetRegistry, assetPrefix?: string, replace: boolean = false): pc.StandardMaterial {
        // Podivat se zda material z danym prefixem jiz je v asset registru
        if (assets) {
            let asset = assets.find(assetPrefix + material.name, pc.eAssetType.material);

            if (asset) {
                if (!replace)
                    return asset.resource as pc.StandardMaterial;

                (<pc.Material>asset.resource).destroy();
                assets.remove(asset);
            }
        }

        let mat = material.clone();

        Object.keys(data).forEach((key: string) => {
            (<any>mat)[key] = (<any>data)[key];
        });

        mat.update();

        if (assets) {
            let asset = new pc.Asset(assetPrefix + mat.name, pc.eAssetType.material);

            asset.resource = mat;
            assets.add(asset);
        }

        return mat;
    }

    //-------------------------------------------------------------------------
    /**
     * Vypocita celkovy AABB pro zadanou entitu. Pri vypoctu pouzije i decirinne entity.
     * @param entity 
     * @param res Do teto promenne bude ulozen vysledek
     */
    //-------------------------------------------------------------------------
    static getEntityTotalAABB(entity: pc.Entity, res: pc.BoundingBox): void {
        res.halfExtents.set(0, 0, 0);

        // Total AABB modelu entity
        this.getModelTotalAABB(entity.model, res);

        // Pridat AABB dcerinnych entit
        entity.children.forEach((child: pc.GraphNode) => {
            if (child instanceof pc.Entity)
                this.getModelTotalAABB((<pc.Entity>child).model, res);
        });
    }

    //-------------------------------------------------------------------------
    /**
     * Vypocita celkovy AABB pro zadany model.
     * @param model 
     * @param totAABB 
     */
    //-------------------------------------------------------------------------
    static getModelTotalAABB(model: pc.ModelComponent, totAABB: pc.BoundingBox, ): void {
        if (model) {
            let meshCnt = model.meshInstances.length;

            if (meshCnt != 0) {
                let meshId = 0;

                // Inicializace vysledneho bounding boxu
                if (totAABB.halfExtents.x == 0) {
                    let aabb = model.meshInstances[0].aabb;

                    totAABB.center.copy(aabb.center);
                    totAABB.halfExtents.copy(aabb.halfExtents);

                    meshId = 1;
                }

                while (meshId < meshCnt) {
                    totAABB.add(model.meshInstances[meshId++].aabb);
                }
            }
        }
    }
}